import React from 'react'
import { Table, TableBody, TableHead, TableRow, withStyles } from '@material-ui/core';
import styles from './styles'
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TemplateStopTableRow from './TemplateStopTableRow';
import { Droppable } from 'react-beautiful-dnd';
import DefaultConfig from './config';
import Columns from './columns';
import { Portlet, PortletContent, TableCellWithConfig, TableSettings } from 'components';
import { getTableKey } from 'services/util/tableConfigHelper';
import { DndHelperElementTypes, DndHelperService } from 'services/dndHelper/dndHelperService';
import useTableConfig from 'hooks/useTableConfig';
import { TableKind } from 'services/enums/TableKind';
import { displayModes } from 'services/enums/displayModes';


function TemplateStopTable(props) {

  const { classes, t, template, className, deleteStopFromTemplate, displayMode } = props;
  const rootClassName = classNames(className, classes.root);
  const uniqueTemplateId = DndHelperService.getUniqueTourId('{}', template.id);

  const config = useTableConfig(DefaultConfig, displayMode, getTableKey(TableKind.TemplateStopTable, displayMode))

  return (
    <div style={{ position: 'relative' }}>
      <TableSettings
        updateConfig={config.updateConfig}
        tableConfig={config.config}
        columns={Columns}
        className={classes.tableSettings}
        buttonOptic
        useNamesAsTranslateString
      />
      <Portlet className={rootClassName}>
        <PortletContent noPadding>
          <div style={{ overflow: 'auto', maxHeight: '326px' }}>
            <Table
              size="medium"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {config.columnConfigs.map(columnConfig => (
                    <TableCellWithConfig
                      key={columnConfig.order}
                      config={columnConfig}
                      className={classes.tableHeader}
                      boxShadowColor={columnConfig.order === 1 ? template.color : null}
                    >
                      {Columns[columnConfig.columnName].header({ t, classes })}
                    </TableCellWithConfig>
                  ))}
                </TableRow>
              </TableHead>
              <Droppable
                droppableId={uniqueTemplateId}
                type={DndHelperElementTypes.Stop}
              >
                {(provided) => (
                  <TableBody
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {template.stops.map((stop, index) => {
                      return (
                        <TemplateStopTableRow
                          columnConfigs={config.columnConfigs}
                          deleteStopFromTemplate={(stopId) => deleteStopFromTemplate(stopId, template)}
                          index={index}
                          key={stop.id}
                          stop={stop}
                          uniqueTemplateId={uniqueTemplateId}
                        />
                      );
                    })}
                    {provided.placeholder}
                  </TableBody>
                )}
              </Droppable>
            </Table>
          </div>
        </PortletContent>
      </Portlet>
    </div>
  );
}

TemplateStopTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  deleteStopFromTemplate: PropTypes.func.isRequired,
  displayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
  t: PropTypes.func.isRequired,
  template: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withTranslation())(TemplateStopTable);
